import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isAppUserEventsLoading = (state: TRootState): boolean =>
  arrayContains(state.appUser.openRequests, [
    Actions.findAppUserEventsRequest.type,
    Actions.assignAppUserEventsRequest.type,
  ]);
